import React, { Component } from 'react'
import { connect } from 'react-redux'
import { totalPriceCal } from '../../JS/totalPriceCal'
import { setTotalOrderPrice, setHCommerceSavedOrders } from '../../../action/hcommerce'
import { CMSPath } from '../../../config/constant'
import PlaceOrder from './placeOrder'
import { getGuestInRoom } from '../../../action/action'
import { hCommColor } from '../../JS/colorConfig'
import { setShowPlaceOrder } from '../../action/hCommerce2';
import $ from 'jquery';
import { removeItemHandler } from './itemActions';
import { contScrollToBottom, contScrollToTop, hideScrolltoTopHandler } from '../../JS/scroll';
import {withTranslation} from "react-i18next";
import { getDefaultAnalyticsLabel } from '../../JS/utility'
import { sendAnalytics } from '../../../action/homeAction'

class AdditionalDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showDetails: true,
            showCheckOut: false,
            savedOrders: [],
            showScrollToTop:false,
            guestComment: localStorage.getItem("GuestCommentHcommerce"),
        }
        // this.myOrderCont = document.getElementById("my-order")
    }

    componentWillMount() {
        let savedOrders = localStorage.getItem("savedOrders");
        if (savedOrders && savedOrders !== "null") {
            savedOrders = JSON.parse(savedOrders);
        } else {
            savedOrders = []
        }
        let totalPrice = totalPriceCal();
        this.props.setTotalOrderPrice(totalPrice);
        this.setState({ savedOrders: savedOrders });
        // this.props.getGuestInRoom(this.props.guestDetail);
    }

    setShowDetails = () => {
        this.setState({ showDetails: !this.state.showDetails, showCheckOut: false })
        this.props.openAdditionalDetail(false)

    }

    componentWillUnmount(){
        $("body").removeClass("overlay-cast");
    }

    setGuestComment = (event) => {
        this.setState({guestComment: event.target.value})
        localStorage.setItem('GuestCommentHcommerce', event.target.value)
    }

    componentDidUpdate(preProp,prevState) {
        if (preProp.hCommerceSavedOrders !== this.props.hCommerceSavedOrders) {
            let savedOrders = localStorage.getItem("savedOrders");
            if (savedOrders && savedOrders !== "null") {
                savedOrders = JSON.parse(savedOrders);
            } else {
                savedOrders = []
            }
            this.setState({ savedOrders: savedOrders });
        }
        hCommColor(this.props.menuColor);
    }

    checkOut = () => {
        this.props.setShowPlaceOrder(true)
        this.props.openAdditionalDetail(false)
    }

    // afterSubmit = (event) => {
    //     console.log("called On submit")
    //     event.preventDefault();
    // }

    
    componentDidMount(){
        if(this.props.mapOpened){
            this.setState({ showDetails: false, showCheckOut: true });
        }
        hCommColor(this.props.menuColor);

        let additionalRequestsEventSent = localStorage.getItem("additionalRequestsEventSent") == "true"
        if(!additionalRequestsEventSent){
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.props.currentWidgets.widgetType, 
                "ADDITIONAL REQUESTS", 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), storeName: this.props.storeInfo.storeName, pageName: "ADDITIONAL REQUESTS"},
                0, 
                this.props.guestIsLoggedIn,
                () => localStorage.setItem("additionalRequestsEventSent", true)
            );
        }
    }

    render() {
        const { t } = this.props
        return (
            <section className={`my-orders ${this.state.showDetails ? "open" : ""}`} >{console.log('Rendered Additional detail page')}
                <div className="orders-container">
                    <div className="orders-heading">
                        <h5>Additional Requests</h5>
                        <a onClick={this.setShowDetails} className="order-toggle">
                            <i className={
                                this.state.showDetails ? "fas fa-lg fa-chevron-down" : "fas fa-lg fa-chevron-up"
                            }
                            ></i>
                        </a>
                    </div>
                    <form style={!this.state.showDetails ? { display: "none" } : {}}>
                        <div className="orders-body-container" style={{Display:"block"}}>
                            <div className="orders-body">
                                <div className="form-row">
                                    <label for="del-pref">If you have any special requests, please let us know</label>
                                    <div className="custom-select">
                                        <input value={this.state.guestComment} onChange={this.setGuestComment} rows="5" className="text-area"/>
                                    </div>
                                </div>
                            </div>
                            <div className="controls">
                                <input
                                    className="inputSubmit" 
                                    onClick={this.checkOut} type="submit" name="place order" value="Next" />
                                
                            </div>
                        </div>
                    </form>
                </div>
            </section>        
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        // currentPage: state.store.Hcommerce.currentPage,
        // serverTime: state.store.home.serverTimeDate.time,
        // CheckedInGuest: state.store.CheckedInGuest,
        // currentWidget: state.store.sideNavBar.currentWidget,
        // serverDate: state.store.home.serverTimeDate,
        // deliveryLocations: state.store.Hcommerce.deliveryLocations,
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        totalPrice: state.store.Hcommerce.totalPrice,
        hCommerceSavedOrders: state.store.Hcommerce.hCommerceSavedOrders,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        storeInfo: state.store.Hcommerce.storeInfo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
    }
}

export default connect(
    mapStateToProps,
    {
        // changePage,
        getGuestInRoom,
        // sendOrder,
        // popupOpenClose,
        // setLoadingMass,
        // getDeliveryLocation,
        // setOrderDetailPage
        setTotalOrderPrice,
        setShowPlaceOrder,
        setHCommerceSavedOrders,
        sendAnalytics
    }
)(withTranslation('translations')(AdditionalDetails));